import { useEffect, useRef } from "react";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";

import { Firebase } from "@/shared/services/firebase";

export function FirebaseAuthUI({
  uiConfig,
  firebase,
  className,
}: {
  uiConfig: firebaseui.auth.Config;
  firebase: Firebase;
  className?: string;
}) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth);
    ui.start(containerRef.current!, uiConfig);

    return () => {
      ui.reset();
    };
    // Start the auth UI once per mount. `firebase.auth` is a module-level singleton, and
    // `uiConfig.signInSuccessUrl` is inert because `signInSuccessWithAuthResult` returns
    // false, so neither can go stale. Callers construct `new Firebase(...)` inline on
    // every render, so depending on them would tear down and restart the auth UI
    // continuously — which is the empty-login-card failure this component exists to avoid.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div ref={containerRef} className={className} />;
}
